import { Form, Spin, Typography } from "antd/es";
import { connect } from "react-redux";
import {
  Button,
  HorizontalStack,
  Icon,
  KCol,
  KDrawer,
  KPanel,
  KRow,
  KTable,
  KTableColumn,
  KTableHeader,
  KTableRow,
  Label,
  TextInput,
  VerticalStack,
} from "../../components/web-components";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { withContext } from "../../shared/hoc/with-context";
import { withForm } from "../../shared/hoc/with-form";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Layout2_Screen } from "../layout2/layout2";
import { Station_List_ScreenBase } from "./station_list-base";

import { STDCustomer_View_Screen } from "../stdcustomer_view/stdcustomer_view";
import { STDStations_Form_Screen } from "../stdstations_form/stdstations_form";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [];

class Station_List_Screen extends Station_List_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Layout2_Screen
          form={this.props.form}
          initialValues={{ station_list_416063_value: undefined }}
          screenInputs={this.props.screenInputs}
          setMasterPageInitLoaded={this.setMasterPageInitLoaded}
          setMasterPageRecurringLoaded={this.setMasterPageRecurringLoaded}
          isMasterPageInitLoaded={this.state.isMasterPageInitLoaded}
          isMasterPageRecurringLoaded={this.state.isMasterPageRecurringLoaded}
          shouldTriggerPageInit={this.state.shouldTriggerPageInit}
          setShouldTriggerPageInit={this.setShouldTriggerPageInit}
          callCallbackFunction={this.callCallbackFunction.bind(this)}
        >
          <Spin spinning={this.state.spinnerCount > 0}>
            <>
              <div
                key="-1"
                id="station_list_body"
                style={
                  {
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    backgroundImage:
                      "url(" +
                      KuikaAppManager.GetBackendUrl() +
                      "/resource/runtime/byid?resourceId=36585bdc-597d-4614-c3dd-08de7b48b8ee)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "left",
                    display: "block",
                    overflow: "auto",
                    minHeight:
                      "calc(100vh - 60px - 60px - 0px - 0px - 0px - 0px)",
                    maxHeight:
                      "calc(100vh - 60px - 60px - 0px - 0px - 0px - 0px)",
                    height: "calc(100vh - 60px - 60px - 0px - 0px - 0px - 0px)",
                  } as any
                }
              >
                <KRow
                  key="818264"
                  id="818264"
                  align="top"
                  justify="start"
                  horizontalGutter={0}
                  verticalGutter={0}
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "rgba(40, 58, 80, 0.2)",
                      paddingTop: 8,
                      paddingRight: 8,
                      paddingBottom: 8,
                      paddingLeft: 8,
                      alignItems: "flex-start",
                      textAlign: "-webkit-left",
                    } as any
                  }
                >
                  <KCol
                    key="700083"
                    id="700083"
                    xs={8}
                    sm={8}
                    md={8}
                    lg={8}
                    xl={8}
                    xxl={8}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  ></KCol>
                  <KCol
                    key="5796"
                    id="5796"
                    xs={8}
                    sm={8}
                    md={8}
                    lg={8}
                    xl={8}
                    xxl={8}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  ></KCol>
                  <KCol
                    key="339816"
                    id="339816"
                    xs={8}
                    sm={8}
                    md={8}
                    lg={8}
                    xl={8}
                    xxl={8}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "center",
                        textAlign: "-webkit-right",
                      } as any
                    }
                  >
                    <HorizontalStack
                      key="942128"
                      id="942128"
                      direction="horizontal"
                      size={12}
                      overflowX="auto"
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 0,
                          paddingRight: 0,
                          paddingBottom: 0,
                          paddingLeft: 0,
                          alignItems: "center",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <VerticalStack
                        key="451052"
                        id="451052"
                        direction="vertical"
                        size={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            textAlign: "-webkit-right",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <Label
                          key="687210"
                          id="687210"
                          value={
                            this.state.GetUserWithGroupDetails?.at?.(0)
                              ?.fullName ?? undefined
                          }
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Roboto",
                              fontWeight: 600,
                              fontSize: "14px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                        <Label
                          key="498145"
                          id="498145"
                          value={
                            this.state.GetUserWithGroupDetails?.at?.(0)
                              ?.groupName ?? undefined
                          }
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 600,
                              fontSize: "12px",
                              color: "rgba(190, 199, 212, 1)",
                              lineHeight: "20px",
                            } as any
                          }
                        ></Label>
                      </VerticalStack>
                      <Icon
                        key="317777"
                        id="317777"
                        iconName="account_circle"
                        style={
                          {
                            borderTopLeftRadius: 28,
                            borderTopRightRadius: 28,
                            borderBottomRightRadius: 28,
                            borderBottomLeftRadius: 28,
                            borderTopWidth: 1,
                            borderRightWidth: 1,
                            borderBottomWidth: 1,
                            borderLeftWidth: 1,
                            borderColor: "rgba(228, 228, 231, 1)",
                            borderStyle: "solid",
                            paddingTop: "",
                            paddingRight: "",
                            paddingBottom: "",
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "36px",
                            color: "rgba(228, 228, 231, 1)",
                            letterSpacing: "1px",
                          } as any
                        }
                      ></Icon>
                    </HorizontalStack>
                  </KCol>
                </KRow>
                <KRow
                  key="20407"
                  id="20407"
                  align="top"
                  justify="start"
                  horizontalGutter={0}
                  verticalGutter={0}
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      paddingTop: 8,
                      paddingRight: 8,
                      paddingBottom: 8,
                      paddingLeft: 8,
                      alignItems: "flex-start",
                      textAlign: "-webkit-left",
                    } as any
                  }
                >
                  <KCol
                    key="695775"
                    id="695775"
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <KRow
                      key="148230"
                      id="148230"
                      align="top"
                      justify="start"
                      horizontalGutter={0}
                      verticalGutter={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 24,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KCol
                        key="696984"
                        id="696984"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <Label
                          key="673538"
                          id="673538"
                          value={ReactSystemFunctions.translate(
                            this.ml,
                            673538,
                            "value",
                            this.defaultML
                          )}
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 600,
                              fontSize: "26px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                      </KCol>
                    </KRow>
                    <KRow
                      key="884083"
                      id="884083"
                      align="top"
                      justify="start"
                      horizontalGutter={0}
                      verticalGutter={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KCol
                        key="804028"
                        id="804028"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-center",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KPanel
                          key="148377"
                          id="148377"
                          scrolling="hidden"
                          scrollRadius={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(255, 255, 255, 1)",
                              backgroundImage:
                                "url(" +
                                KuikaAppManager.GetBackendUrl() +
                                "/resource/runtime/byid?resourceId=37841317-7130-4525-c3df-08de7b48b8ee)",
                              backgroundPosition: "center",
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KRow
                            key="39828"
                            id="39828"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 0,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KCol
                              key="370373"
                              id="370373"
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                              xl={12}
                              xxl={12}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <Form.Item
                                className="kFormItem"
                                name="station_list_416063_value"
                              >
                                <TextInput
                                  key="416063"
                                  id="416063"
                                  onPressEnter={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.Station_ListComponent_416063_onPressEnter();
                                  }}
                                  onBlur={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.Station_ListComponent_416063_onBlur();
                                  }}
                                  kuikaRef={
                                    this
                                      .station_list_416063_value_kuikaTextInputRef
                                  }
                                  placeholder={ReactSystemFunctions.translate(
                                    this.ml,
                                    416063,
                                    "placeholder",
                                    this.defaultML
                                  )}
                                  allowClear={false}
                                  bordered={true}
                                  disabled={false}
                                  type="text"
                                  iconColor="rgba(0, 0, 0, 1)"
                                  formatter="None"
                                  isCharOnly={false}
                                  autoComplete={true}
                                  inputMode="all"
                                  speechToText={false}
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderBottomRightRadius: 8,
                                      borderBottomLeftRadius: 8,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "rgba(217, 217, 217, 1)",
                                      borderStyle: "solid",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      height: "44px",
                                      maxHeight: "44px",
                                      minHeight: "44px",
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "block",
                                      fontFamily: "Roboto",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></TextInput>
                              </Form.Item>
                            </KCol>
                            <KCol
                              key="379449"
                              id="379449"
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                              xl={12}
                              xxl={12}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "center",
                                  textAlign: "-webkit-right",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <HorizontalStack
                                key="202705"
                                id="202705"
                                direction="horizontal"
                                size={12}
                                overflowX="auto"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    alignItems: "center",
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <Button
                                  key="716128"
                                  id="716128"
                                  onClick={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.Station_ListComponent_716128_onClick();
                                  }}
                                  showCursorPointer
                                  visibility={this.state.isComp716128Visible}
                                  label={ReactSystemFunctions.translate(
                                    this.ml,
                                    716128,
                                    "label",
                                    this.defaultML
                                  )}
                                  size="middle"
                                  loading={false}
                                  ghost={false}
                                  block={false}
                                  htmlType="button"
                                  icon="add"
                                  danger={false}
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderBottomRightRadius: 8,
                                      borderBottomLeftRadius: 8,
                                      backgroundColor: "rgba(0, 88, 184, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 8,
                                      paddingRight: 16,
                                      paddingBottom: 8,
                                      paddingLeft: 16,
                                      width: "100px",
                                      height: "44px",
                                      maxHeight: "44px",
                                      minHeight: "44px",
                                      alignItems: "center",
                                      textAlign: "-webkit-center",
                                      display: "inline",
                                      fontFamily: "Roboto",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(255, 255, 255, 1)",
                                      lineHeight: "22px",
                                    } as any
                                  }
                                ></Button>
                              </HorizontalStack>
                            </KCol>
                          </KRow>
                          <KRow
                            key="195637"
                            id="195637"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 0,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KCol
                              key="681099"
                              id="681099"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <KTable
                                key="984215"
                                id="984215"
                                kuikaRef={
                                  this.station_list_984215_value_kuikaTableRef
                                }
                                form={this.props.form}
                                dataSource={this.state.GetAllStations}
                                size="middle"
                                bordered={true}
                                loading={false}
                                rowKey="id"
                                transformedOnMobileResolution={false}
                                hideHeaderOnMobileResolution={false}
                                showHeader={true}
                                fixedHeader={false}
                                editable={false}
                                tableWidthMode="fit"
                                globalSearch={false}
                                searchable={true}
                                shouldSearchOnChange={false}
                                searchDelay={200}
                                sorter={true}
                                filtering={true}
                                pagination={true}
                                pageSize={10}
                                showSizeChanger={false}
                                paginationSelectedTextColor="#246eff"
                                paginationUnselectedTextColor="#000"
                                columnChooser={false}
                                resizableColumns={false}
                                striped={false}
                                stripedColor="#F5F7FA"
                                rowHoverBgColor="#fafafa"
                                insertRowActive={false}
                                insertRowPosition="top"
                                showNoDataFound={true}
                                nodatafoundmessage={ReactSystemFunctions.translate(
                                  this.ml,
                                  984215,
                                  "nodatafoundmessage",
                                  this.defaultML
                                )}
                                multiSelect={false}
                                multiSelectScope="page"
                                export={false}
                                editableAlwaysActive={false}
                                style={
                                  {
                                    borderTopLeftRadius: 12,
                                    borderTopRightRadius: 12,
                                    borderBottomRightRadius: 12,
                                    borderBottomLeftRadius: 12,
                                    borderColor: "rgba(140, 140, 140, 1)",
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    backgroundColor: "transparent",
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <KTableHeader
                                  key="116652"
                                  id="116652"
                                  hideOnMobileResolution={false}
                                  textDirection="Default"
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "transparent",
                                      paddingBottom: 5,
                                      fontFamily: "Roboto",
                                      fontWeight: 500,
                                      fontSize: "12px",
                                      color: "rgba(36, 105, 204, 1)",
                                      lineHeight: "20px",
                                    } as any
                                  }
                                ></KTableHeader>
                                <KTableRow
                                  key="176870"
                                  id="176870"
                                  hoverFontColor="red"
                                  hoverBgColor="#F5F5F5"
                                  style={
                                    {
                                      borderBottomWidth: 1,
                                      borderColor: "rgba(217, 217, 217, 1)",
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "transparent",
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <KTableColumn
                                    key="522498"
                                    id="522498"
                                    title={ReactSystemFunctions.translate(
                                      this.ml,
                                      522498,
                                      "title",
                                      this.defaultML
                                    )}
                                    alwaysVisibleOnMobileResolution={false}
                                    hideFiltering={false}
                                    hideSorting={false}
                                    hideSearch={false}
                                    footerOptions="none"
                                    footerFontSize={14}
                                    footerFontColor="rgb(68, 68, 68)"
                                    excludeFromExport={false}
                                    footerFontWeight="Regular"
                                    style={
                                      {
                                        borderColor: "transparent",
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "center",
                                        textAlign: "-webkit-center",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <Label
                                      key="560807"
                                      id="560807"
                                      onClick={(e?: any) => {
                                        if (e && e.stopPropagation)
                                          e.stopPropagation();
                                        this.Station_ListComponent_560807_onClick();
                                      }}
                                      showCursorPointer
                                      value="[datafield:customerName]"
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderTopLeftRadius: 12,
                                          borderTopRightRadius: 12,
                                          borderBottomRightRadius: 12,
                                          borderBottomLeftRadius: 12,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Roboto",
                                          fontWeight: 500,
                                          fontSize: "12px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    ></Label>
                                  </KTableColumn>
                                  <KTableColumn
                                    key="254687"
                                    id="254687"
                                    title={ReactSystemFunctions.translate(
                                      this.ml,
                                      254687,
                                      "title",
                                      this.defaultML
                                    )}
                                    alwaysVisibleOnMobileResolution={false}
                                    hideFiltering={false}
                                    hideSorting={false}
                                    hideSearch={false}
                                    footerOptions="none"
                                    footerFontSize={14}
                                    footerFontColor="rgb(68, 68, 68)"
                                    excludeFromExport={false}
                                    footerFontWeight="Regular"
                                    style={
                                      {
                                        borderTopWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                        borderLeftWidth: 1,
                                        borderStyle: "solid",
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "center",
                                        textAlign: "-webkit-center",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <Label
                                      key="300454"
                                      id="300454"
                                      onClick={(e?: any) => {
                                        if (e && e.stopPropagation)
                                          e.stopPropagation();
                                        this.Station_ListComponent_300454_onClick();
                                      }}
                                      showCursorPointer
                                      value="[datafield:stationIdentifier]"
                                      maxLine={1}
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderTopLeftRadius: 12,
                                          borderTopRightRadius: 12,
                                          borderBottomRightRadius: 12,
                                          borderBottomLeftRadius: 12,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          backgroundColor:
                                            "rgba(36, 105, 204, 0.2)",
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Roboto",
                                          fontWeight: 500,
                                          fontSize: "12px",
                                          color: "rgba(36, 105, 204, 1)",
                                        } as any
                                      }
                                    ></Label>
                                  </KTableColumn>
                                  <KTableColumn
                                    key="484727"
                                    id="484727"
                                    title={ReactSystemFunctions.translate(
                                      this.ml,
                                      484727,
                                      "title",
                                      this.defaultML
                                    )}
                                    alwaysVisibleOnMobileResolution={false}
                                    hideFiltering={false}
                                    hideSorting={false}
                                    hideSearch={false}
                                    footerOptions="none"
                                    footerFontSize={14}
                                    footerFontColor="rgb(68, 68, 68)"
                                    excludeFromExport={false}
                                    footerFontWeight="Regular"
                                    style={
                                      {
                                        borderTopWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                        borderLeftWidth: 1,
                                        borderStyle: "solid",
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "center",
                                        textAlign: "-webkit-center",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <Label
                                      key="622308"
                                      id="622308"
                                      onClick={(e?: any) => {
                                        if (e && e.stopPropagation)
                                          e.stopPropagation();
                                        this.Station_ListComponent_622308_onClick();
                                      }}
                                      showCursorPointer
                                      value="[datafield:stationName]"
                                      maxLine={1}
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Roboto",
                                          fontWeight: 500,
                                          fontSize: "12px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    ></Label>
                                  </KTableColumn>
                                  <KTableColumn
                                    key="722542"
                                    id="722542"
                                    title={ReactSystemFunctions.translate(
                                      this.ml,
                                      722542,
                                      "title",
                                      this.defaultML
                                    )}
                                    alwaysVisibleOnMobileResolution={false}
                                    hideFiltering={false}
                                    hideSorting={false}
                                    hideSearch={false}
                                    footerOptions="none"
                                    footerFontSize={14}
                                    footerFontColor="rgb(68, 68, 68)"
                                    excludeFromExport={false}
                                    footerFontWeight="Regular"
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "center",
                                        textAlign: "-webkit-center",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <Label
                                      key="972316"
                                      id="972316"
                                      value="[datafield:stationLocation]"
                                      maxLine={1}
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-center",
                                          display: "inline",
                                          fontFamily: "Roboto",
                                          fontWeight: 500,
                                          fontSize: "12px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    ></Label>
                                  </KTableColumn>
                                  <KTableColumn
                                    key="584200"
                                    id="584200"
                                    title={ReactSystemFunctions.translate(
                                      this.ml,
                                      584200,
                                      "title",
                                      this.defaultML
                                    )}
                                    alwaysVisibleOnMobileResolution={false}
                                    hideFiltering={false}
                                    hideSorting={false}
                                    hideSearch={false}
                                    footerOptions="none"
                                    footerFontSize={14}
                                    footerFontColor="rgb(68, 68, 68)"
                                    excludeFromExport={false}
                                    footerFontWeight="Regular"
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "center",
                                        textAlign: "-webkit-center",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <Label
                                      key="657561"
                                      id="657561"
                                      value="[datafield:stationLocationNo]"
                                      maxLine={1}
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-center",
                                          display: "inline",
                                          fontFamily: "Roboto",
                                          fontWeight: 500,
                                          fontSize: "12px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    ></Label>
                                  </KTableColumn>
                                  <KTableColumn
                                    key="579129"
                                    id="579129"
                                    title={ReactSystemFunctions.translate(
                                      this.ml,
                                      579129,
                                      "title",
                                      this.defaultML
                                    )}
                                    alwaysVisibleOnMobileResolution={false}
                                    hideFiltering={false}
                                    hideSorting={false}
                                    hideSearch={false}
                                    footerOptions="none"
                                    footerFontSize={14}
                                    footerFontColor="rgb(68, 68, 68)"
                                    excludeFromExport={false}
                                    footerFontWeight="Regular"
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "center",
                                        textAlign: "-webkit-center",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <Label
                                      key="828516"
                                      id="828516"
                                      value="[datafield:createdAt]"
                                      maxLine={1}
                                      formatter="date"
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-center",
                                          display: "inline",
                                          fontFamily: "Roboto",
                                          fontWeight: 500,
                                          fontSize: "12px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    ></Label>
                                  </KTableColumn>
                                  <KTableColumn
                                    key="630236"
                                    id="630236"
                                    title={ReactSystemFunctions.translate(
                                      this.ml,
                                      630236,
                                      "title",
                                      this.defaultML
                                    )}
                                    alwaysVisibleOnMobileResolution={false}
                                    hideFiltering={true}
                                    hideSorting={false}
                                    hideSearch={true}
                                    footerOptions="none"
                                    footerFontSize={14}
                                    footerFontColor="rgb(68, 68, 68)"
                                    excludeFromExport={false}
                                    footerFontWeight="Regular"
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "center",
                                        textAlign: "-webkit-center",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <Icon
                                      key="826142"
                                      id="826142"
                                      visibility={
                                        this.state.isComp826142Visible
                                      }
                                      visibilityCondition={(rowData: object) =>
                                        ReactSystemFunctions.isEqualTo(
                                          rowData.stationStatus,
                                          false
                                        )
                                      }
                                      iconName="circle"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "11px",
                                          color: "rgba(239, 68, 68, 1)",
                                          letterSpacing: "1px",
                                        } as any
                                      }
                                    ></Icon>
                                    <Icon
                                      key="900638"
                                      id="900638"
                                      visibility={
                                        this.state.isComp900638Visible
                                      }
                                      visibilityCondition={(rowData: object) =>
                                        ReactSystemFunctions.isEqualTo(
                                          rowData.stationStatus,
                                          true
                                        )
                                      }
                                      iconName="circle"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "11px",
                                          color: "rgba(34, 197, 94, 1)",
                                          letterSpacing: "1px",
                                        } as any
                                      }
                                    ></Icon>
                                    <Label
                                      key="471335"
                                      id="471335"
                                      visibility={
                                        this.state.isComp471335Visible
                                      }
                                      value="[datafield:stationStatus]"
                                      maxLine={1}
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-center",
                                          display: "inline",
                                          fontFamily: "Roboto",
                                          fontWeight: 500,
                                          fontSize: "12px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    ></Label>
                                  </KTableColumn>
                                  <KTableColumn
                                    key="590473"
                                    id="590473"
                                    title={ReactSystemFunctions.translate(
                                      this.ml,
                                      590473,
                                      "title",
                                      this.defaultML
                                    )}
                                    alwaysVisibleOnMobileResolution={false}
                                    hideFiltering={true}
                                    hideSorting={true}
                                    hideSearch={true}
                                    footerOptions="none"
                                    footerFontSize={14}
                                    footerFontColor="rgb(68, 68, 68)"
                                    excludeFromExport={false}
                                    footerFontWeight="Regular"
                                    style={
                                      {
                                        borderTopWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                        borderLeftWidth: 1,
                                        borderStyle: "solid",
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        width: "100px",
                                        alignItems: "center",
                                        textAlign: "-webkit-center",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <HorizontalStack
                                      key="234913"
                                      id="234913"
                                      direction="horizontal"
                                      size={8}
                                      overflowX="auto"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <Icon
                                        key="953107"
                                        id="953107"
                                        onClick={(e?: any) => {
                                          if (e && e.stopPropagation)
                                            e.stopPropagation();
                                          this.Station_ListComponent_953107_onClick();
                                        }}
                                        showCursorPointer
                                        iconName="visibility"
                                        style={
                                          {
                                            borderTopLeftRadius: 8,
                                            borderTopRightRadius: 8,
                                            borderBottomRightRadius: 8,
                                            borderBottomLeftRadius: 8,
                                            borderTopWidth: 1,
                                            borderRightWidth: 1,
                                            borderBottomWidth: 1,
                                            borderLeftWidth: 1,
                                            borderColor: "rgba(0, 88, 184, 1)",
                                            borderStyle: "solid",
                                            paddingTop: 4,
                                            paddingRight: 4,
                                            paddingBottom: 4,
                                            paddingLeft: 4,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "16px",
                                            color: "rgba(0, 88, 184, 1)",
                                            letterSpacing: "1px",
                                          } as any
                                        }
                                      ></Icon>
                                      <Icon
                                        key="36925"
                                        id="36925"
                                        onClick={(e?: any) => {
                                          if (e && e.stopPropagation)
                                            e.stopPropagation();
                                          this.Station_ListComponent_36925_onClick();
                                        }}
                                        showCursorPointer
                                        visibility={
                                          this.state.isComp36925Visible
                                        }
                                        visibilityCondition={(
                                          rowData: object
                                        ) =>
                                          ReactSystemFunctions.isEqualTo(
                                            this.state.GetUserWithGroupDetails[0]?.stationsEdit?.toString(),
                                            true
                                          )
                                        }
                                        iconName="create"
                                        style={
                                          {
                                            borderTopLeftRadius: 8,
                                            borderTopRightRadius: 8,
                                            borderBottomRightRadius: 8,
                                            borderBottomLeftRadius: 8,
                                            borderTopWidth: 1,
                                            borderRightWidth: 1,
                                            borderBottomWidth: 1,
                                            borderLeftWidth: 1,
                                            borderColor:
                                              "rgba(108, 117, 125, 1)",
                                            borderStyle: "solid",
                                            paddingTop: 4,
                                            paddingRight: 4,
                                            paddingBottom: 4,
                                            paddingLeft: 4,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "16px",
                                            color: "rgba(108, 117, 125, 1)",
                                            letterSpacing: "1px",
                                          } as any
                                        }
                                      ></Icon>
                                      <Icon
                                        key="220701"
                                        id="220701"
                                        onClick={(e?: any) => {
                                          if (e && e.stopPropagation)
                                            e.stopPropagation();
                                          this.Station_ListComponent_220701_onClick();
                                        }}
                                        showCursorPointer
                                        visibility={
                                          this.state.isComp220701Visible
                                        }
                                        visibilityCondition={(
                                          rowData: object
                                        ) =>
                                          ReactSystemFunctions.isEqualTo(
                                            this.state.GetUserWithGroupDetails[0]?.stationsDelete?.toString(),
                                            true
                                          )
                                        }
                                        iconName="delete_outline"
                                        style={
                                          {
                                            borderTopLeftRadius: 8,
                                            borderTopRightRadius: 8,
                                            borderBottomRightRadius: 8,
                                            borderBottomLeftRadius: 8,
                                            borderTopWidth: 1,
                                            borderRightWidth: 1,
                                            borderBottomWidth: 1,
                                            borderLeftWidth: 1,
                                            borderColor: "rgba(220, 53, 69, 1)",
                                            borderStyle: "solid",
                                            paddingTop: 4,
                                            paddingRight: 4,
                                            paddingBottom: 4,
                                            paddingLeft: 4,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "16px",
                                            color: "rgba(220, 53, 69, 1)",
                                            letterSpacing: "1px",
                                          } as any
                                        }
                                      ></Icon>
                                    </HorizontalStack>
                                  </KTableColumn>
                                </KTableRow>
                              </KTable>
                            </KCol>
                          </KRow>
                        </KPanel>
                      </KCol>
                    </KRow>
                  </KCol>
                </KRow>
                <KDrawer
                  key="723183"
                  id="723183"
                  placement="right"
                  onClose={() => {
                    this.setState({ NavVisible723183: false }, () => {
                      this.callCallbackFunction(723183);
                    });
                  }}
                  visible={this.state.NavVisible723183}
                  width="450px"
                  height="100vh"
                  push={true}
                  closable={true}
                  children={
                    this.state.NavVisible723183 && (
                      <STDStations_Form_Screen
                        onClose={() => {
                          this.setState({ NavVisible723183: false }, () => {
                            this.callCallbackFunction(723183);
                          });
                        }}
                        screenInputs={window.kuika.navigationScreenInputs}
                        navigator={this.props.navigator}
                        form={this.props.form}
                        context={this.props.context}
                      />
                    )
                  }
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      paddingTop: 0,
                      paddingRight: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      fontSize: "14px",
                      color: "rgba(68, 68, 68, 1)",
                    } as any
                  }
                ></KDrawer>
                <KDrawer
                  key="675016"
                  id="675016"
                  placement="right"
                  onClose={() => {
                    this.setState({ NavVisible675016: false }, () => {
                      this.callCallbackFunction(675016);
                    });
                  }}
                  visible={this.state.NavVisible675016}
                  width="450px"
                  height="100"
                  push={true}
                  closable={true}
                  children={
                    this.state.NavVisible675016 && (
                      <STDStations_Form_Screen
                        onClose={() => {
                          this.setState({ NavVisible675016: false }, () => {
                            this.callCallbackFunction(675016);
                          });
                        }}
                        screenInputs={window.kuika.navigationScreenInputs}
                        navigator={this.props.navigator}
                        form={this.props.form}
                        context={this.props.context}
                      />
                    )
                  }
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      paddingTop: 0,
                      paddingRight: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      fontSize: "14px",
                      color: "rgba(68, 68, 68, 1)",
                    } as any
                  }
                ></KDrawer>
                <KDrawer
                  key="94067"
                  id="94067"
                  placement="right"
                  onClose={() => {
                    this.setState({ NavVisible94067: false }, () => {
                      this.callCallbackFunction(94067);
                    });
                  }}
                  visible={this.state.NavVisible94067}
                  width="500px"
                  height="100vh"
                  push={true}
                  closable={true}
                  children={
                    this.state.NavVisible94067 && (
                      <STDCustomer_View_Screen
                        onClose={() => {
                          this.setState({ NavVisible94067: false }, () => {
                            this.callCallbackFunction(94067);
                          });
                        }}
                        screenInputs={window.kuika.navigationScreenInputs}
                        navigator={this.props.navigator}
                        form={this.props.form}
                        context={this.props.context}
                      />
                    )
                  }
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      paddingTop: 0,
                      paddingRight: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      fontSize: "14px",
                      color: "rgba(68, 68, 68, 1)",
                    } as any
                  }
                ></KDrawer>
              </div>
            </>
          </Spin>
        </Layout2_Screen>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withForm(
        withHistory(
          connect(mapStateToProps, mapDispatchToProps)(Station_List_Screen)
        )
      )
    )
  )
);
export { tmp as Station_List_Screen };
//export default tmp;
//export { tmp as Station_List_Screen };
